import React, { memo } from 'react';
import ExternalLink from './ExternalLink';
import Pin from '@/components/shared/maps/components/Pin';
import { CustomIconLinkProps } from './components/interfaces';

const PositionLink = ({ href, label, icon = true }: CustomIconLinkProps & { icon?: boolean }) => {
  if (!href || !label) return null;

  return (
    <ExternalLink
      Icon={icon ? Pin : undefined}
      label={label}
      href={href}
      target="_blank"
      className="!items-start"
    />
  );
};

export default memo(PositionLink);
